import {
  ADD_GROUP_PARTICIPANT,
  ADD_GROUP_PARTICIPANT_SUCCESS,
  ADD_GROUP_PARTICIPANT_CLEAN,
  ADD_GROUP_PARTICIPANT_ERROR,
} from "./actionTypes"

export const addGroupParticipant = form => ({
  type: ADD_GROUP_PARTICIPANT,
  payload: { form },
})

export const addGroupParticipantSuccess = group => {
  return {
    type: ADD_GROUP_PARTICIPANT_SUCCESS,
    payload: { group },
  }
}

export const addGroupParticipantClean = () => {
  return {
    type: ADD_GROUP_PARTICIPANT_CLEAN,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: ADD_GROUP_PARTICIPANT_ERROR,
    payload: error,
  }
}
